<template>
  <div>
    <el-table :data="getList" border style="width: 100%">
      <el-table-column width="50" prop="id" label="ID"> </el-table-column>
      <el-table-column show-overflow-tooltip prop="rightsCode" label="权益编号">
        <template slot-scope="scope">
          <span class="overflow-ellipsis" slot="reference">{{ scope.row.rightsCode }}</span>
        </template>
      </el-table-column>
      <el-table-column show-overflow-tooltip prop="rightsName" label="权益名称">
        <template slot-scope="scope">
          <span class="overflow-ellipsis" slot="reference">{{ scope.row.rightsName }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="clientTypes" label="客户端类型">
        <template slot-scope="scope">
          <el-tag v-for="item in scope.row.clientTypes.split(',')" :key="item" size="small"
            style="margin-right: 5px;margin-bottom: 5px;">{{ item }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column show-overflow-tooltip prop="description" label="描述文案">
        <template slot-scope="scope">
          <span v-if="!scope.row.description">暂无描述</span>
          <span v-else class="overflow-ellipsis" slot="reference">{{ scope.row.description }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="limitParams" label="限制参数">
        <template slot-scope="scope">
          <el-tag v-for=" item  in  scope.row.limitParams.split(',') " :key="item" size="small"
            style="margin-right: 5px;margin-bottom: 5px;">{{ item }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column width="80" prop="state" label="生效状态"> </el-table-column>
      <el-table-column width="80" v-if="getCurrentTab === 'localData'" prop="reviewStatus" label="审核状态">
      </el-table-column>
      <el-table-column show-overflow-tooltip width="120" prop="remark" label="备注">
        <template slot-scope="scope">
          <span v-if="!scope.row.remark">暂无备注</span>
          <span v-else class="overflow-ellipsis" slot="reference">{{ scope.row.remark }}</span>
        </template>
      </el-table-column>
      <el-table-column fixed="right" v-if="getCurrentTab === 'localData'" label="操作">
        <template slot-scope="scope">
          <!-- 查看日志 -->
          <el-button v-auth="'MEMBER_RIGHTS_MANAGE_LOG'" type="text" size="small"
            @click="checkLog(scope.row.id)">查看日志</el-button>
          <el-button v-auth="'MEMBER_RIGHTS_MANAGE_EDIT'" v-if="scope.row.reviewStatus !== '待审核'" type="text" size="small"
            @click="handleEdit(scope.row)">编辑</el-button>
          <!-- 审核+提交审核+撤销审核 -->
          <el-button v-auth="'MEMBER_RIGHTS_MANAGE_AUDIT'" v-if="scope.row.reviewStatus === '待审核'" type="text"
            size="small" @click="handleAudit(scope.row)">审核</el-button>
          <el-button v-auth="'MEMBER_RIGHTS_MANAGE_FOR_AUDIT'" v-if="scope.row.reviewStatus === '草稿'" type="text"
            size="small" @click="handleSubmitAudit(scope.row)">提交审核</el-button>
          <el-button v-auth="'MEMBER_RIGHTS_MANAGE_CANCEL_AUDIT'" v-if="scope.row.reviewStatus === '待审核'" type="text"
            size="small" @click="handleCancelAudit(scope.row)">撤销审核</el-button>
          <!-- 删除 -->
          <el-button v-auth="'MEMBER_RIGHTS_MANAGE_DEL'" type="text" size="small"
            @click="handelDel(scope.row.id)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- //^ ^--------------编辑对话框-------------^ ^ -->
    <AddDialog :addDialog.sync="editDialog" title="编辑会员权益" :addFrom="addFrom" @updateData="updateData"></AddDialog>
    <!-- //^ ^-------------查看日志对话框--------------^ ^ -->
    <logDialog :logDialog.sync="logDialog" :id.sync="logId"></logDialog>
    <!-- //^ ^--------------审核对话框-------------^ ^ -->
    <AuditDialog :auditDialog.sync="auditDialog" :afterUpdate.sync="afterUpdate" :beforeUpdate.sync="beforeUpdate"
      :showAuditOpinion.sync="showAuditOpinion" @updateData="updateData"></AuditDialog>
  </div>
</template>

<script>
import AddDialog from "./memberRightAddDialog.vue";
import logDialog from "./memberRightLog.vue";
import AuditDialog from "./memberRightAuditRight.vue";
import {
  deleteMemberRightLocal,
  getClientType,
  getLimitParams,
  auditMemberRightShot,
  revokeAudit
} from "@/api/memberNew/memberRight.js";
import Message from "@/components/Message";
export default {
  name: "WebSassMemberRightTable",
  components: {
    AddDialog,
    logDialog,
    AuditDialog
  },
  props: {
    list: {
      type: Array,
      default: () => []
    },
    currentTab: {
      type: String,
      default: ""
    }
  },
  computed: {
    getList() {
      return this.list;
    },
    getCurrentTab() {
      return this.currentTab;
    }
  },
  data() {
    return {
      /** 日志的id */
      logId: "",
      /** 编辑对话框的显隐 */
      editDialog: false,
      /** 查看日志对话框的显隐 */
      logDialog: false,
      /** 审核对话框的显隐 */
      auditDialog: false,
      /** 审核意见的显隐 */
      showAuditOpinion: false,
      /** 编辑回填的数据 */
      addFrom: {
        rights_code: "",
        rights_name: "",
        client_types: "",
        description: "",
        limit_params: "",
        typeStatus: "",
        review_status: "",
        remark: ""
      },
      /** 修改前的审核数据 */
      beforeUpdate: {},
      /** 修改后的审核数据 */
      afterUpdate: {},
      /** 客户端类型 */
      clientTypes: "",
      /** 限制参数 */
      limitParams: ""
    };
  },

  created() {
    /** promiseAll */
    Promise.all([this.getClientType(), this.getLimitParams()])
  },

  methods: {
    /** 编辑点击事件 */
    handleEdit(row) {
      /** 处理数据再传递 */
      /** 构建一个新的对象 */
      const editObj = {
        id: row.id,
        rightsCode: row.rightsCode,
        rightsName: row.rightsName,
        clientTypes: this.translateClientType(row.clientTypes, "value"),
        description: row.description,
        limitParams: this.translateLimitParams(row.limitParams, "value"),
        state: this.translateState(row.state, "value"),
        reviewStatus: row.reviewStatus,
        remark: row.remark
      };
      console.log("编辑回填的数据", editObj);
      this.editDialog = true;
      this.addFrom = editObj;
    },
    /** 通知父组件 */
    updateData() {
      this.$emit("updateData");
    },
    /** 查看日志事件 */
    checkLog(id) {
      console.log(this.logDialog);
      /** 把id传过去 */
      this.logId = id;
      this.logDialog = true;
      console.log(this.logDialog);
    },
    /** 提交审核 */
    async handleSubmitAudit(row) {
      console.log("提交审核传递过来的数据", row);
      /** 调用接口 */
      const result = await auditMemberRightShot(row.id);
      console.log("获取修改前后的数据响应", result.data.data);
      /** 如果修改前有数据 */
      if (result.data.data.online.id) {
        /** 构建一个新对象 */
        const beforeObj = {
          id: result.data.data.online.id,
          rightsCode: result.data.data.online.rightsCode,
          rightsName: result.data.data.online.rightsName,
          clientTypes: this.translateClientType(
            result.data.data.online.clientTypes
          ),
          description: result.data.data.online.description,
          limitParams: this.translateLimitParams(
            result.data.data.online.limitParams
          ).length
            ? this.translateLimitParams(result.data.data.online.limitParams)
            : "无",
          state: this.translateState(result.data.data.online.state),
          reviewStatus: result.data.data.online.reviewStatus,
          remark: result.data.data.online.remark
        };
        this.beforeUpdate = beforeObj;
      } else {
        this.beforeUpdate = {};
      }

      /** 构建一个新对象 */
      const afterObj = {
        id: result.data.data.local.id,
        rightsCode: result.data.data.local.rightsCode,
        rightsName: result.data.data.local.rightsName,
        clientTypes: this.translateClientType(
          result.data.data.local.clientTypes
        ),
        description: result.data.data.local.description,
        limitParams: this.translateLimitParams(
          result.data.data.local.limitParams
        ).length
          ? this.translateLimitParams(result.data.data.local.limitParams)
          : "无",
        state: this.translateState(result.data.data.local.state),
        reviewStatus: result.data.data.local.reviewStatus,
        remark: result.data.data.local.remark
      };
      this.afterUpdate = afterObj;
      // this.beforeUpdate = beforeObj;
      console.log("修改前的数据", this.beforeUpdate);
      console.log("修改后的数据", this.afterUpdate);

      this.auditDialog = true;
    },
    /** 审核事件 */
    async handleAudit(row) {
      console.log("传递审核的数据", row);
      /** 调用接口 */
      const result = await auditMemberRightShot(row.id);
      console.log("获取修改前后的数据响应", result.data.data);
      /** 如果修改前有数据 */
      if (result.data.data.online.id) {
        /** 构建一个新对象 */
        const beforeObj = {
          id: result.data.data.online.id,
          rightsCode: result.data.data.online.rightsCode,
          rightsName: result.data.data.online.rightsName,
          clientTypes: this.translateClientType(
            result.data.data.online.clientTypes
          ),
          description: result.data.data.online.description,
          limitParams: this.translateLimitParams(
            result.data.data.online.limitParams
          ).length
            ? this.translateLimitParams(result.data.data.online.limitParams)
            : "无",
          state: this.translateState(result.data.data.online.state),
          reviewStatus: result.data.data.online.reviewStatus,
          remark: result.data.data.online.remark
        };
        this.beforeUpdate = beforeObj;
      } else {
        this.beforeUpdate = {};
      }

      /** 构建一个新对象 */
      const afterObj = {
        id: result.data.data.local.id,
        rightsCode: result.data.data.local.rightsCode,
        rightsName: result.data.data.local.rightsName,
        clientTypes: this.translateClientType(
          result.data.data.local.clientTypes
        ),
        description: result.data.data.local.description,
        limitParams: this.translateLimitParams(
          result.data.data.local.limitParams
        ).length
          ? this.translateLimitParams(result.data.data.local.limitParams)
          : "无",
        state: this.translateState(result.data.data.local.state),
        reviewStatus: result.data.data.local.reviewStatus,
        remark: result.data.data.local.remark
      };
      this.afterUpdate = afterObj;
      // this.beforeUpdate = beforeObj;
      console.log("修改前的数据", this.beforeUpdate);
      console.log("修改后的数据", this.afterUpdate);

      this.auditDialog = true;
      this.auditDialog = true;
      this.showAuditOpinion = true;
    },
    /** 撤销审核事件 */
    handleCancelAudit(row) {
      console.log("传递撤销审核的数据", row);
      /** 二次询问 */
      this.$confirm("是否确认撤销审核?", "提示", {
        confirmButtonText: "确认",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(async () => {
          /** 调用接口 */
          const { data } = await revokeAudit({
            id: row.id
          });
          console.log("撤销审核接口的响应", data);
          /** 如果成功提示用户 */
          if (data.code === 200) {
            Message.success("撤销审核成功");
            /** 更新数据 */
            this.$emit("updateData");
          } else {
            Message.error("撤销审核失败");
          }
        })
        .catch(() => {
          Message.info("已取消撤销审核");
        });
    },
    /** 删除事件 */
    async handelDel(id) {
      /** 二次询问用户 */
      this.$confirm("是否确认删除该会员权益项?", "提示", {
        confirmButtonText: "确认",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(async () => {
          console.log("删除事件传递给接口的id", id);
          const { data } = await deleteMemberRightLocal(id);
          console.log("删除接口的响应", data);
          /** 如果成功提示用户 */
          if (data.code === 200) {
            Message.success("删除成功");
            /** 更新数据 */
            this.$emit("updateData");
          } else {
            Message.error("删除失败");
          }
        })
        .catch(() => {
          Message.info("已取消删除");
        });
    },
    /** 加载客户端类型 */
    async getClientType() {
      const { data } = await getClientType();
      console.log("加载客户端类型的响应", data.data[0].children);
      this.clientTypes = data.data[0].children;
    },
    /** 获取限制参数 */
    async getLimitParams() {
      const { data } = await getLimitParams();
      console.log("获取限制参数的响应", data.data[0].children);
      this.limitParams = data.data[0].children;
    },
    //^ ^--------------数据处理相关 start-------------^ ^
    /** 客户端类型转化 */
    translateClientType(clientTypes, option) {
      // 将传入的字符串按逗号分隔为数组
      const keyArr = clientTypes.split(",");

      // 处理每个键对应的客户端类型值
      /** 根据不同的option 返回不同的值 */
      if (option === "value") {
        const translatedArr = keyArr.map(key => {
          const clientType = this.clientTypes.find(
            item => item.dictValue === key
          );
          return clientType ? clientType.dictKey : "";
        });

        // 返回字符串数组
        return translatedArr;
      } else {
        const translatedArr = keyArr.map(key => {
          const clientType = this.clientTypes.find(
            item => item.dictKey === key
          );
          return clientType ? clientType.dictValue : "";
        });
        // 返回字符串数组
        return translatedArr;
      }
    },
    /** 限制参数类型转化 */
    translateLimitParams(limitParam, option) {
      // 将传入的字符串按逗号分隔为数组
      const keyArr = limitParam.split(",");

      // 处理每个键对应的客户端类型值
      /** 根据不同的option 返回不同的值 */
      if (option === "value") {
        let translatedArr = keyArr.map(key => {
          const limitParam = this.limitParams.find(
            item => item.dictValue === key
          );
          return limitParam ? limitParam : "";
        });

        //过滤掉空的item
        translatedArr = translatedArr.filter(item => item !== "");
        translatedArr = translatedArr.map(item => {
          return {
            dictKey: item.dictKey,
            dictValue: item.dictValue,
            isShow: true
          };
        });
        return translatedArr;
      } else {
        let translatedArr = keyArr.map(key => {
          const limitParam = this.limitParams.find(
            item => item.dictKey === key
          );
          console.log('limitParam', limitParam);
          return limitParam ? limitParam.dictValue : "";
        });
        // 返回字符串数组
        //过滤掉空的item
        translatedArr = translatedArr.filter(item => item !== "");
        return translatedArr;
      }
    },
    /** 状态的转化 */
    translateState(state, option) {
      if (option === "value") {
        return state === "失效" ? 0 : 1;
      } else return state === '0' ? "失效" : "生效";
    }
  }
};
</script>

<style lang="scss" scoped>
.overflow-ellipsis {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
</style>
